import { http } from '@/api'

export interface AppVersion {
  id: number
  version: string
  number: number
  describe: string
  file_url: string
  file_size: string
  silence: 0 | 1
  force: 0 | 1
  package_type: 0 | 1
  issue_status: 0 | 1
  terminal: 'android' | 'ios'
  created_at: string
  updated_at: string
}

export interface AppVersionListParams {
  page_no?: number
  page_size?: number
  terminal?: 'android' | 'ios'
  version?: string
}

export interface CreateAppVersionData {
  version: string
  number: number
  describe?: string
  file_url?: string
  file_size?: string
  silence?: 0 | 1
  force?: 0 | 1
  package_type?: 0 | 1
  issue_status?: 0 | 1
  terminal: 'android' | 'ios'
}

export interface UpdateAppVersionData {
  version?: string
  number?: number
  describe?: string
  file_url?: string
  file_size?: string
  silence?: 0 | 1
  force?: 0 | 1
  package_type?: 0 | 1
  issue_status?: 0 | 1
  terminal?: 'android' | 'ios'
}

export const appVersionApi = {
  getList(params?: AppVersionListParams): Promise<ApiResponse<PaginatedData<AppVersion>>> {
    return http.get('app-version/list', { params })
  },

  getDetail(id: number): Promise<ApiResponse<AppVersion>> {
    return http.get(`app-version/${id}`)
  },

  create(data: CreateAppVersionData): Promise<ApiResponse<null>> {
    return http.post('app-version/add', data)
  },

  update(id: number, data: UpdateAppVersionData): Promise<ApiResponse<null>> {
    return http.put(`app-version/${id}`, data)
  },

  delete(id: number): Promise<ApiResponse<null>> {
    return http.delete(`app-version/${id}`)
  },
}
